import React from 'react'
import { StyledFooter } from './styled'

const Footer = props => (
  <StyledFooter>
    <small>FE v{window?.__RUNTIME_CONFIG__?.REACT_APP_VERSION}{props.buildInfo && props.buildInfo.version ? ` / BE v${props.buildInfo.version}` : ''}</small>
  </StyledFooter>
)
export default Footer
